import { render, staticRenderFns } from "./LimitedBadgeList.vue?vue&type=template&id=ea92bdda&scoped=true&"
import script from "./LimitedBadgeList.vue?vue&type=script&lang=js&"
export * from "./LimitedBadgeList.vue?vue&type=script&lang=js&"
import style0 from "./LimitedBadgeList.vue?vue&type=style&index=0&id=ea92bdda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea92bdda",
  null
  
)

export default component.exports